
import React from 'react';
import { identity_matrix } from "../../../lib/matrix";
import Portfolio from "../../portfolio/Portfolio";
import {DashboardContainer} from "../../funcs/utils";
import {string_cmp} from "../../../lib/js-utils";
import {RebalanceTable} from "../SANotification/rebalance-table";

const menuItems = [
  {
    id: "portfolio",
    label: "Portfolio",
  },
  {
    id: "cash",
    label: "Cash",
  },
  {
    id: "categories",
    label: "All Categories",
  },
  {
    id: "securities",
    label: "All Securities",
  }
];

class PortfolioDashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      portfolio: null,
      id: null,
      loading: false,
      error: false,
      // Portfolio
      menu: menuItems[0].id,
    }

    this.view_matrix = identity_matrix();
    this.view_matrix_inv = identity_matrix();
  }

  componentDidMount = () => {
    const username = this.props.username;
    const acct_index = parseInt(this.props.acct_index, 10);
    if (!username && !Number.isInteger(acct_index)) {
      console.log("Can't load portfolio", username, acct_index);
      return;
    }

    if (!this.props.portfolio[username] || !this.props.portfolio[username][acct_index]) {
      this.props.loadPortfolio(
        username, acct_index, this.props.client.chart_colors);
      this.props.loadUserQueueItems(username, acct_index);
    }
    const irr = this.props.irr
    if (!irr.category || !irr.scores) {
      this.props.loadIRRScores();
    }
  };

  renderTitle = title => {
    const h1Style = {
      color: "#00F", // Blue
      paddingTop: "2rem",
    };
    const divStyle = {
      width: "100%",
      paddingBottom: "1rem",
    };
    return (
      <div style={divStyle}>
        <h1 className="title" style={h1Style}>{title}</h1>
      </div>
    );
  };

  onMenuChange = ev => {
    this.setState({
      menu: ev.target.value,
    })
  };

  renderMenu = () => {
    const containerStyle = {
      float: "right",
      margin: "2rem",
    };

    const items = menuItems.map(item => {
      return (
        <option id={item.id} key={item.id} value={item.id}>
          { item.label }
        </option>
      );
    });
    const selectStyle = {
      fontSize: "1.5rem",
    };
    return (
      <div style={containerStyle}>
        <select
          style={selectStyle}
          onChange={this.onMenuChange}
          value={this.state.menu}>

          { items }

        </select>
      </div>
    );
  };

  onSpanSelected = id => {
    this.setState({
      selected_rebalance: id,
    })
  }

  getRebalItems = () => {
    const notifs = this.props.notification;
    const username = this.props.username;
    const index = parseInt(this.props.acct_index, 10);
    if (!notifs || !notifs[username] || !notifs[username][index]) {
      return [];
    }
    const user_notifs = notifs[username][index];

    const rebal_items = [
      ...user_notifs.closed_notifs,
      ...user_notifs.canceled_notifs,
    ];
    if (user_notifs.current_notif) {
      rebal_items.push(user_notifs.current_notif);
    }

    rebal_items.sort(
      (item_a, item_b) => string_cmp(item_a.id, item_b.id));
    return rebal_items;
  }

  render = () => {
    return (
      <div>
        <div className="img-col">
          <div className="page-container">
            <DashboardContainer
              client={this.props.client}>
              <Portfolio
                username={this.props.username}
                on_span_selected={this.onSpanSelected}
                index={parseInt(this.props.acct_index, 10)}/>
              <RebalanceTable
                component={this}
                selected={this.state.selected_rebalance}
                items={this.getRebalItems()}/>
            </DashboardContainer>
          </div>
        </div>
      </div>
    );
  }
}

export { PortfolioDashboard };
